export enum NodeContentType {
  // 富文本
  RICH_TEXT = 0,
  // 视频
  VIDEO = 1,
  // 习题
  EXERCISES = 2,
  // 认证
  PROFESSIONAL_CERTIFICATION = 3,
}

export enum CampStudyState {
  // 未开始
  NOT_START_LEARNING = 0,
  // 学习中
  STUDYING = 1,
  // 打卡失败
  CAMP_FAIL = 2,
  // 打卡成功
  CAMP_SUCCESS = 3,
  // 等待公布成绩
  WAITING_RESULTS = 4,
}

export const CampStudyStateOptions = [
  {
    text: '未开始',
    value: CampStudyState.NOT_START_LEARNING,
  },
  {
    text: '学习中',
    value: CampStudyState.STUDYING,
  },
  {
    text: '打卡失败',
    value: CampStudyState.CAMP_FAIL,
  },
  {
    text: '打卡成功',
    value: CampStudyState.CAMP_SUCCESS,
  },
];

export enum NodeStudyState {
  // 未开始学习
  NOT_START_LEARNING = 0,
  // 学习中
  STUDYING = 1,
  // 已提交
  NODE_SUCCESS = 2,
  // 失败
  NODE_FAIL = 3,
}

export const NodeStudyStateOptions = [
  {
    text: '未开始学习',
    value: NodeStudyState.NOT_START_LEARNING,
  },
  {
    text: '学习中',
    value: NodeStudyState.STUDYING,
  },
  {
    text: '已提交',
    value: NodeStudyState.NODE_SUCCESS,
  },
  {
    text: '失败',
    value: NodeStudyState.NODE_FAIL,
  },
];

export const NodeStudyStateLog = [
  {
    text: '未开始',
    value: NodeStudyState.NOT_START_LEARNING,
  },
  {
    text: '打卡中',
    value: NodeStudyState.STUDYING,
  },
  {
    text: '已打卡',
    value: NodeStudyState.NODE_SUCCESS,
  },
  {
    text: '打卡失败',
    value: NodeStudyState.NODE_FAIL,
  },
];

export enum QuestionType {
  // 单选题
  SINGLE_CHOICE = 0,
  // 多选题
  MULTIPLE_CHOICE = 1,
  // 判断题
  TURE_OR_FALSE = 2,
  // 主观题
  SUBJECTIVE = 3,
}
export enum NodeReviewState {
  // 无须批阅
  WITHOUT_REVIEW = 0,
  // 等待批阅
  WAIT_REVIEW = 1,
  // 已批阅
  HAVE_REVIEW = 2,
}
export interface ExercisesResultsType {
  id: string;
  questionErrorNumber: number;
  questionReviewNumber: number;
  subjectiveScore: number;
}
